import { Field } from 'formik'
import React from 'react'

import { Checkbox, Fieldset, Input, RadioButton, Subsection } from '@fourthwall/components'

import * as S from './styled'

export type SoundScanProps = {
  isSoundScanProduct: boolean
  disabled?: boolean
}

export const SoundScan = ({ isSoundScanProduct, disabled = false }: SoundScanProps) => {
  const renderSoundScanInputs = () => {
    if (!isSoundScanProduct) return null

    return (
      <S.Container>
        <Fieldset.Row inner>
          <S.RadioGroupLabel>Product format</S.RadioGroupLabel>
        </Fieldset.Row>
        <Fieldset.Row inner>
          <Field
            component={RadioButton}
            name="format"
            label="Single"
            checkedValue="SINGLE"
            disabled={disabled}
          />
        </Fieldset.Row>
        <Fieldset.Row inner>
          <Field
            component={RadioButton}
            name="format"
            label="Album"
            checkedValue="ALBUM"
            disabled={disabled}
          />
        </Fieldset.Row>
        <Fieldset.Row inner>
          <S.InputWrapper>
            <Field
              component={Input}
              name="soundScanCode"
              label="SoundScan code (EAN/UPC)"
              disabled={disabled}
            />
          </S.InputWrapper>
        </Fieldset.Row>
      </S.Container>
    )
  }

  return (
    <Subsection title="SoundScan">
      <Fieldset>
        <Field
          component={Checkbox}
          name="isSoundScanProduct"
          label="This is a SoundScan product"
          disabled={disabled}
        />
        {renderSoundScanInputs()}
      </Fieldset>
    </Subsection>
  )
}
